import { api } from "@api/api";
import { PartnerHistoryEntry } from "@modules/partners/types";

function unwrapList<T>(data: unknown): T[] {
  if (Array.isArray(data)) return data as T[];
  return ((data as { results?: T[] })?.results ?? []) as T[];
}

export async function getReferralHistoryService(
  id: number | string
): Promise<PartnerHistoryEntry[]> {
  const { data } = await api.get(`/v1/partner_referral_admin/${id}/history/`);
  return unwrapList<PartnerHistoryEntry>(data);
}
